import { faTimes, faCheck, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../AuthContext";
import Alert from "../components/Alert";
import Button from "../components/Button";
import { ButtonContainer } from "../components/ButtonContainer";
import CenterContainer from "../components/CenterContainer";
import { FormRow, FormLabel, RawFormInput, RawFormError, FormText, FormError } from "../components/FormElements";
import Title from "../components/Title";
import { UserDeleteRequest, UserDeleteRequestSchema } from "consumerhouse-shared";
import { Translation, useLanguage } from "../useLanguage";
import { AnyListener, useForm } from "typed-react-form";
import { RateLimitError } from "../api";

export default function DeleteAccount() {
    const { client, auth, setAuth } = useContext(AuthContext);
    const language = useLanguage();
    const history = useHistory();
    const form = useForm<UserDeleteRequest>({ password: "" }, (data) => UserDeleteRequestSchema.validate(data));

    return (
        <CenterContainer width="500px" style={{ margin: "2em 0" }}>
            <Title>{language("delete-account")}</Title>
            <form
                onSubmit={async (ev) => {
                    ev.preventDefault();
                    await form.validate();
                    if (form.error) return;
                    form.setState({ isSubmitting: true });
                    try {
                        let res = await client.fetch("/user/delete", form.values);
                        if (res.status === "ok") {
                            setAuth(null);
                            history.push("/");
                        } else {
                            form.setError("password", language(res.password as any));
                        }
                    } catch (ex) {
                        if (ex instanceof RateLimitError) {
                            form.setError("password", language("error-delete-account-limit"));
                        } else {
                            console.error("Could not delete account", ex);
                        }
                    }
                    form.setState({ isSubmitting: false });
                }}>
                <Alert style={{ margin: "1em 0", flexWrap: "nowrap" }} color="#e38b29" textColor="white" icon={faExclamationCircle}>
                    {language("delete-account-info")}
                </Alert>
                <FormRow>
                    <FormLabel>{language("delete-account-password")}</FormLabel>
                    <FormText form={form} type="password" name="password" />
                </FormRow>
                <hr />
                <ButtonContainer>
                    <Button type="button" color="#666" onClick={() => history.goBack()} icon={faTimes}>
                        {language("delete-account-cancel")}
                    </Button>
                    <Button icon={faCheck} color="#56a44f">
                        {language("delete-account-delete")}
                    </Button>
                </ButtonContainer>
            </form>
        </CenterContainer>
    );
}
